var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom grupo-auditoria"
  }, [_c('div', {
    staticClass: "card-header border-0 pt-6"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "to": {
        name: 'grupoEmpresa'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-1"
  }), _vm._v(" Voltar ao grupo ")])], 1)]), _c('div', {
    staticClass: "card-body pt-4"
  }, [_vm.carregandoInicial ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : _vm.grupo ? [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.aplicarFiltros.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('b-form-group', {
    staticClass: "col-lg-4",
    attrs: {
      "label": "Evento",
      "label-for": "audit-acao"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "audit-acao",
      "options": _vm.opcoesAcao
    },
    model: {
      value: _vm.filtros.acao,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "acao", $$v);
      },
      expression: "filtros.acao"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-3",
    attrs: {
      "label": "Data inicial",
      "label-for": "audit-inicio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "audit-inicio",
      "type": "date"
    },
    model: {
      value: _vm.filtros.inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "inicio", $$v);
      },
      expression: "filtros.inicio"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-3",
    attrs: {
      "label": "Data final",
      "label-for": "audit-fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "audit-fim",
      "type": "date",
      "min": _vm.filtros.inicio
    },
    model: {
      value: _vm.filtros.fim,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "fim", $$v);
      },
      expression: "filtros.fim"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-lg-2",
    attrs: {
      "label": "Ação",
      "label-class": "invisible"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block d-flex align-items-center justify-content-center",
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando,
      "data-testid": "filtrar-auditoria"
    }
  }, [_vm._v(" Filtrar ")])])], 1)]), _vm.carregando ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : [_vm.registros.length ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center"
  }, [_vm._m(1), _c('tbody', _vm._l(_vm.registros, function (registro) {
    return _c('tr', {
      key: registro.id_grupo_empresa_auditoria
    }, [_c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatarDataHora(registro.created_at)) + " ")]), _c('td', [_c('span', {
      staticClass: "label label-light-primary label-inline"
    }, [_vm._v(" " + _vm._s(_vm.labelAcao(registro.acao)) + " ")])]), _c('td', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(" " + _vm._s(registro.executor && registro.executor.nome) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" " + _vm._s(registro.executor && registro.executor.usuario) + " ")])]), _c('td', [_vm._v(_vm._s(_vm.descricaoRegistro(registro)))]), _c('td', [_vm._v(_vm._s(registro.ip || "—"))])]);
  }), 0)])]) : _c('div', {
    staticClass: "alert alert-light-info mb-0"
  }, [_vm._v(" Nenhum evento encontrado para os filtros selecionados. ")]), _vm.paginacao.last_page > 1 ? _c('div', {
    staticClass: "d-flex justify-content-center mt-6"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.paginacao.total,
      "per-page": _vm.paginacao.per_page
    },
    on: {
      "input": _vm.carregarAuditoria
    },
    model: {
      value: _vm.paginacao.current_page,
      callback: function callback($$v) {
        _vm.$set(_vm.paginacao, "current_page", $$v);
      },
      expression: "paginacao.current_page"
    }
  })], 1) : _vm._e()]] : _c('div', {
    staticClass: "alert alert-light-warning mb-0"
  }, [_vm._v(" Configure um grupo empresarial antes de consultar a auditoria. ")])], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-title"
  }, [_c('div', [_c('h3', {
    staticClass: "card-label mb-1"
  }, [_vm._v("Auditoria do grupo")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Histórico de trocas, acessos e cópias de cadastros entre empresas. ")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data e hora")]), _c('th', [_vm._v("Evento")]), _c('th', [_vm._v("Executado por")]), _c('th', [_vm._v("Detalhes")]), _c('th', [_vm._v("IP")])])]);
}];
export { render, staticRenderFns };